export default __webpack_public_path__ + "98c218e3bebdf3152c7b9f8e9a94fc03.png";